import { MatPaginatorIntl } from '@angular/material/paginator';
import { Subject } from 'rxjs';

export class getFrenchPaginatorIntl implements MatPaginatorIntl {
  public changes = new Subject<void>();

  public firstPageLabel = 'La première page';

  public itemsPerPageLabel = 'Éléments par page:';

  public lastPageLabel = 'La dernière page';

  public nextPageLabel = 'La page suivante';

  public previousPageLabel = 'La page précédente';

  getRangeLabel(page: number, pageSize: number, length: number): string {
    if (length === 0 || pageSize === 0) {
      return '0 sur ' + length;
    }
    length = Math.max(length, 0);
    const startIndex = page * pageSize;
    const endIndex = startIndex < length ? Math.min(startIndex + pageSize, length) : startIndex + pageSize;
    return startIndex + 1 + ' - ' + endIndex + ' sur ' + length;
  }
}
